module.exports = __webpack_public_path__ + "static/img/title.ae42739.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature/title.png
// module id = cq5h
// module chunks = 7